import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import store from '../../redux/store';
import * as courseSelectors from '../../redux/selectors/course';
import { actions as authActions } from '../../redux/modules/auth';
import config from '../../config';
import sidebarLinks from '../../shared/SideBar/links';
import Mentroship from '../Mentorship/Mentorship';
import ContractsModal from '../ContractsModal';
import { Container, Item } from './styles';
import { RenderNotificationTagNumber } from 'components/NotificationTagNumber';

type TProps = {
  logout: () => {};
  cursos: any;
};

function Navigation({ logout, cursos }: TProps) {
  const [showMentorshipModal, setMentorshipModal] = useState(false);
  const [showContractsModal, setShowContractsModal] = useState(false);

  const renderLink = (item: any) => {
    if (item.openURL)
      return (
        <a href={item.openURL} rel="noopener noreferrer" target="_blank">
          {item.title}
          {!!item.totalNotifications && <strong>{item.totalNotifications}</strong>}
        </a>
      );

    if (item.link) {
      if (item.name === 'start') {
        return (
          <Link to={`/`}>
            {item.title} <RenderNotificationTagNumber name={item.name} />
          </Link>
        );
      } else {
        return (
          <Link to={`/${item.name}`}>
            {item.title} <RenderNotificationTagNumber name={item.name} />
          </Link>
        );
      }
    }
    if (item.tag) {
      return (
        <span>
          {item.title} <RenderNotificationTagNumber name={item.name} />
        </span>
      );
    }

    return (
      <span>
        {item.title} <RenderNotificationTagNumber name={item.name} />
      </span>
    );
  };

  const onClick = (item: any) => {
    switch (item.name) {
      case 'mentorship':
        setMentorshipModal(true);
        break;
      case 'contracts':
        setShowContractsModal(true);
        break;
      case 'oldStudent':
        store.dispatch({ type: 'VERIFY_TOKEN_ACTION' });
        setMentorshipModal(true);
        break;
      case 'logout':
        logout();
        break;
      default:
        store.dispatch({ type: 'VERIFY_TOKEN_ACTION' });
        break;
    }
  };

  const renderSideBarMenu = () => {
    return sidebarLinks(cursos)
      .filter((item) => {
        let envHiddenMenu = false;
        try {
          envHiddenMenu = config.hiddenMenu.includes(item.name);
        } catch {
          // Any exception i gonna ignore, cause probably the environment variable was passed incorrect
        }

        return (typeof item.show === 'undefined' || item?.show) && !envHiddenMenu;
      })
      .map((item) => (
        <Item key={item.name} id={item.name} border={!!item.border} onClick={() => onClick(item)}>
          {renderLink(item)}
        </Item>
      ));
  };

  return (
    <Container>
      {renderSideBarMenu()}
      {/* <Item key="more" id="more" onClick={handleOpenMobile}>
        <span>Mais itens</span>
      </Item> */}
      {showMentorshipModal && <Mentroship setMentorshipModal={setMentorshipModal} />}
      {showContractsModal && <ContractsModal setVisible={setShowContractsModal} />}
    </Container>
  );
}

const mapStateToProps = (state: any) => ({
  cursos: courseSelectors.getEnrollmentsList(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  logout: () => dispatch(authActions.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
